import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import { androidBackButton } from './Utils';

class SignUp extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      email: '',

      nickname: '',

      password1: '',
      password2: '',
    };
  }

  handlePassword1Input = (event) => {
    this.setState({ password1: event.target.value });
  };

  handlePassword2Input = (event) => {
    this.setState({ password2: event.target.value });
  };

  handleNicknameInput = (event) => {
    this.setState({ nickname: event.target.value });
  };

  handleEmailInput = (event) => {
    this.setState({ email: event.target.value });
  };

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
  }

  handleGoBackRoom = () => {
    this.props.navigate(`/Login`);
  };

  handleSignUp = () => {
    // this must be corected, it is false
    // there is no such API in the backend , i must write one

    const requestInput = {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        nickname: this.state.nickname,
        email: this.state.email,
        password: this.state.password1,
        confirmPassword: this.state.password2,
      }),
    };
    fetch(`/api/users/${this.props.cookies.get('code')}`, requestInput)
      .then((res) => res.json())
      .then((data) => {
        this.props.navigate(`/`, {
          state: {
            roomID: data.roomID,
          },
        });
      })

      .catch((error) => {
        console.error('Error:', error);
      });
  };

  render() {
    return (
      <div className="ForgotPasswordHome">
        <h1 className="ForgotPasswordH1">Sign Up</h1>

        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackRoom}></DesignerButton>
        </div>

        <div className="SignUpTextFieldsHolder">
          <label className="TextFieldLabel">Email Address</label>

          <DesignerTextField
            //style={{ position: 'absolute', top: '280px' }}
            type="email"
            value={this.state.email}
            onChange={this.handleEmailInput}
            minlength={4}
            placeholder={'Email Address'}></DesignerTextField>

          <label className="TextFieldLabel">Name / Nickname</label>

          <DesignerTextField
            //style={{ position: 'absolute', top: '280px' }}
            value={this.state.nickname}
            onChange={this.handleNicknameInput}
            minlength={4}
            placeholder={'Name / Nickname'}></DesignerTextField>

          <label className="TextFieldLabel">Password</label>

          <DesignerTextField
            //style={{ position: 'absolute', top: '280px' }}
            type="password"
            value={this.state.password1}
            onChange={this.handlePassword1Input}
            minlength={4}
            placeholder={'Password'}></DesignerTextField>

          <label className="TextFieldLabel">Confirm Password</label>

          <DesignerTextField
            //style={{ position: 'absolute', top: '280px' }}
            type="password"
            value={this.state.password2}
            onChange={this.handlePassword2Input}
            minlength={4}
            placeholder={'Password'}></DesignerTextField>
        </div>

        <div
          className="createButtonOuterDiv"
          style={{ position: 'absolute', bottom: '15px' }}>
          <div className="createButtonInnerDiv">
            <DesignerButton
              class="filledButton"
              disabled={
                this.state.email.length < 10 ||
                this.state.nickname.length < 4 ||
                this.state.password1.length < 5 ||
                this.state.password2.length < 5
              }
              onClick={this.handleSignUp}
              buttonText="Sign Up"></DesignerButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(SignUp);
